import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ZiroFormsModule } from '../forms/ziro-forms.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { LoginComponent } from './login.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SamlSsoConfigContext } from '../admin/contexts/saml-sso-config.context';
import { ZiroButtonComponent } from '../button/button.component';
import { LoadingBlockModule } from '../shared/loading-block/loading-block.module';
import { FooterModule } from '../shared/footer/footer.module';
import { PipesModule } from '../shared/pipes/pipes.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    NgbModule,
    SharedModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    ZiroFormsModule,
    NgSelectModule,
    ZiroButtonComponent,
    LoadingBlockModule,
    FooterModule,
    PipesModule,
  ],
  declarations: [LoginComponent],
  exports: [LoginComponent],
  providers: [SamlSsoConfigContext],
})
export class LoginModule {}
